<template>
  <header class="site-header mobile-header-blue header-style-1">
    <!-- Top bar close -->
    <div class="main-header md-hidden sm-hidden">
      <div class="container-custom">
        <div class="row">
          <div class="col-md-2">
            <div class="logo-brand">
              <img src="../assets/images/logo_cn.png" alt />
            </div>
          </div>
          <div class="col-md-10">
            <div class="main-navigation">
              <ul id="primary-menu" class="menu">
                <li class="menu-item" v-for="(item,index) in menuList" :key="index" :class="{'current-menu-parent' : index === nowIndex, 'menu-item-has-children' : !item.url }" @click="toUrl(index)">
                  <router-link :to="{name: item.url}" class="active_item" exact>{{ item.name }}</router-link>
                  <ul class="sub-menu" v-if="item.list.length > 0">
                    <li class="menu-item" v-for="(v,idx) in item.list" :key="idx" @click="toUrl(index)">
                      <router-link :to="{name: v.url}" class="active_item">{{ v.name }}</router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile header start -->
    <div class="mobile-header">
      <div class="container-custom">
        <div class="row">
          <div class="col-xs-6">
            <div class="logo-brand-mobile">
              <img src="../assets/images/logo.jpg"/>
            </div>
          </div>
          <div class="col-xs-6">
            <div id="menu_toggle" @click="showList($event)">
              <button>≡</button>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="mobile-nav" v-if="isShowList">
              <ul id="primary-menu-mobile" class="mobile-menu">
                <li class="menu-item" v-for="(item,index) in menuList" :key="index" :class="{'current-menu-parent active' : index === nowIndex, 'menu-item-has-children' : !item.url }">
                  <div v-if="item.url" @click="toUrl(index, false)">
                    <router-link :to="{name: item.url}" class="active_item" exact>{{ item.name }}</router-link>
                  </div>
                  <div v-else @click="toUrl(index, true)">
                    <router-link :to="{name: item.url}" class="active_item" exact>{{ item.name }}</router-link>
                    <span class="arrow" v-if="item.list.length > 0">
                      <i class="fa fa-plus"></i>
                    </span>
                  </div>
                  <ul class="sub-menu" v-if="item.list.length > 0 && item.showMore">
                    <li class="menu-item" v-for="(v,idx) in item.list" :key="idx" @click="toUrl(index, false)">
                      <router-link :to="{name: v.url}" class="active_item">{{ v.name }}</router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import $ from "jquery";
// $(function () {
//   $(".mobile-menu li:has(ul)").prepend(
//     '<span class="arrow"><i class="fa fa-plus"></i></span>'
//   );
//   $("#menu_toggle").on("click", function () {
//     $(this).toggleClass("active");

//     if ($(this).hasClass("active")) {
//       $(".mobile-nav").stop(true, true).slideDown();
//     } else {
//       $(".mobile-nav").stop(true, true).slideUp();
//     }
//   });

//   $(".mobile-menu li span.arrow").on("click", function () {
//     $(this).parent().find("> ul").stop(true, true).slideToggle();
//     $(this).toggleClass("active");
//   });
// });

export default {
  data() {
    return {
      isShowList: false,
      nowIndex:0,
      menuList:[
        {
          name:"首页",
          url:"home",
          showMore:false,
          list:{}
        },
        {
          name:"产品信息",
          url:"",
          showMore:false,
          list:[
            { name:"PMS软件",
              url:"services_pms"
            },
            { name:"移动应用",
              url:"services_pos"
            },
            { name:"自助设备",
              url:"services_zzj"
            }
          ]
        },        
        {
          name:"技术服务",
          url:"",
          showMore:false,
          list:[
            { name:"售后服务",
              url:"services_sale"
            },
            { name:"软件下载",
              url:"download"
            },
            { name:"定制服务",
              url:"services_custom"
            }
          ]
        },        
        {
          name:"成功案例",
          url:"project",
          showMore:false,
          list:[]
        },        
        {
          name:"关于汉邦微云",
          url:"",
          showMore:false,
          list:[
            { name:"公司简介",
              url:"about"
            },
            { name:"联系我们",
              url:"content"
            }
          ]
        }
      ]
    };
  },
  methods: {
    showList(e) {
      this.isShowList = !this.isShowList;
      console.log(this.isShowList );
    },
    toUrl(idx,isShow){
      this.nowIndex = idx;
      this.menuList[idx].showMore = !this.menuList[idx].showMore;
      this.isShowList = isShow
      console.log(idx,this.menuList[idx],isShow);
    }
  },
};
</script>

<style scoped>
.main-navigation ul ul li.menu-item-has-children {
  display: inline-block;
  position: absolute;
  top: 30px;
  right: 25px;
  width: 0;
  height: 0;
  content: "\f107";
  color: #bdbebf;
  font-family: "FontAwesome";
  font-weight: 900;
  margin-right: 15px;
  font-size: 13px;
  transform: rotate(-90deg);
}
.main-navigation a:focus,
.mobile-nav a:focus {
  outline-style:none !important;
  -moz-outline-style: none !important;
}
.logo-brand{
  margin-top: 20px;
}
button{
  width: 100%;
  height: 60px;
  background-color: transparent;
  border: none;
  text-align: right;
  font-size: 28px;
  color: #428bca;
}
.mobile-nav{
  display: block !important;
}
.mobile-nav .sub-menu{
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/v-header.vue